import React, { Component } from 'react';
import firebaseApp from '../Firebase/Firebase';
import './chatbothomepagecss.css';
import { allPics } from '../Firebase/TinqerPics';
require('firebase/firestore');

var Modal = require('boron/OutlineModal');
var style = {
    modalStyle: {
        width: 'auto',
        height: '15px',
    }
};
var db = firebaseApp.firestore();


class Chatbotdisplay extends Component {
    constructor(props) {
        super(props);
        // this.showModal = this.showModal.bind(this);
        this.contactUs = this.contactUs.bind(this);
        this.clearForm = this.clearForm.bind(this);
    }

    componentWillMount() {
        //Set up Sendgrid
    }

    contactUs() {
        let nameInput = document.getElementById('nameInput').value,
            businessNameInput = document.getElementById('businessNameInput').value,
            contactNumberInput = document.getElementById('contactNumberInput').value,
            emailInput = document.getElementById('emailInput').value,
            businessWebsiteInput = document.getElementById('businessWebsiteInput').value,
            summaryArea = document.getElementById('summaryArea').value;
        let referThis = this;

        /*const sgEmail = require('@sendgrid/mail');
        sgEmail.setApiKey('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');
        const welcomeTempId = '8ba11742-333b-4412-8c41-c549e85bc056'; */


        if (nameInput === "" || contactNumberInput === "" || emailInput === "") {
            this.refs.denyModal.show();
        } else {
            let emailRef = db.collection('contactUsEmails');
            emailRef.doc(emailInput).set({
                email: emailInput,
                businessName: businessNameInput,
                contactNumber: contactNumberInput,
                name: nameInput,
                businessWebsite: businessWebsiteInput,
                shortIntroduction: summaryArea
            }).then(function () {
                //Success submitting the information. 
                referThis.refs.approvedModal.show();

                /*//Send the email to Customer 
                var newCustomerEmail = new sgEmail.Email({
                    to: emailInput,
                    from: 'tinqer@tinqer.io',
                    html: '<p></p>',
                    subject: 'Thank you for contacting us!'
                });
                newCustomerEmail.addFilter('templates', 'enable', 1);
                newCustomerEmail.addFilter('templates', welcomeTempId);

                sgEmail.send(newCustomerEmail, (err, response) => {
                    if (err) {
                        //There was an error sending email. 
                        referThis.refs.denyModal.show();
                        console.log("Emaill Not sent!");
                    } else {
                        //Success sending email.
                        console.log("Emaill Successfully sent!");
                    }
                }).then(() => {
                    //After that, clear the form. 
                    referThis.clearForm();
                }); */

            }).catch(function (error) {
                document.getElementById('errorArea').innerText = 'Error submitting information. Please try again later.';
                console.error(error);
            });
        }
    }

    //Clear up the form 
    clearForm() {
        document.getElementById('nameInput').value = "";
        document.getElementById('businessNameInput').value = "";
        document.getElementById('contactNumberInput').value = "";
        document.getElementById('emailInput').value = "";
        document.getElementById('businessWebsiteInput').value = "";
        document.getElementById('summaryArea').value = "";
        console.log("Form Cleared!");
    }

    render() {
        const whyTinqerData = [
            {
                icon: "far fa-user",
                mainTitle: 'The Best Customer Service 24/7',
                subtext: 'Customized experience for each potential customer on your website or application. Plus, no matter what time of the day it is, Tinqer Bots always treats a customer politely.',
            },
            {
                icon: "fas fa-location-arrow",
                mainTitle: 'Increase Customer Engagement',
                subtext: 'Our application makes customer interaction as natural as possible, which leads to more satisfaction and increases chances of customer return rate due to personalized suggestions.',
            },
            {
                icon: "fas fa-dollar-sign",
                mainTitle: 'Save Money!',
                subtext: 'Our applications save you time and money on unnecessary questions by easily answering simple queries from your customers. Complex queries will be directed to your Customer Support Agents, making sure your customers never feel unwanted!',
            },
            {
                icon: "far fa-clock",
                mainTitle: 'Teamwork made Easy!',
                subtext: 'Routine work can also be automated, making it easier to stay in sync with your team with bot notifications and custom functions.',
            },
        ];

        return (
            <div /*className="fade-in"*/>
                <section className='text-center chatTitle' style={{ padding: '50px' }}>
                    <div className='textContentTitle'>
                        <h1><b>The Smart Way to Work</b></h1>
                        <h4>Drive sales and improve customer experience with <br />personalized Advertising, Marketing Automation, Customer Service Bots and cutting-edge AI Solutions available 24/7</h4>
                        <div className="icon_list">
                            <img src={allPics.slack_logo}
                                className='slack_logo' alt="slack_logo" />
                            <img src={allPics.fb_msg_logo}
                                className='facebook_logo' alt="facebook_logo" />
                            <img src={allPics.twitterLogo}
                                className='twitter_logo' alt="twitter_logo" />
                        </div>
                        <img src={allPics.chatbot_banner}
                            className="img-rounded chatbot_banner" alt='Chatbot_banner'
                        />
                    </div>
                </section>
                <br />
                <section id="chatbotWhySection">
                    <h2 style={{ paddingRight: '10px', paddingLeft: '10px' }}>Why your business needs Tinqer?</h2>
                    <div className="row chatbotWhyCards">
                        {
                            whyTinqerData.map((data, x) => 
                                <div className="col-md-3 col-xs-2" key={x}>
                                    <div className="card" id="chatbotWhyCard">
                                        <i className={data.icon}
                                            style={{ marginRight: 'auto', marginLeft: 'auto', fontSize: '40px', color: 'blue' }}></i>
                                        <hr style={{ backgroundColor: 'blue' }} />
                                        <p style={{ fontSize: '20px' }} >
                                            <b>{data.mainTitle}</b> <br />
                                        </p>
                                        <p style={{ fontSize: '17px', textAlign: 'left' }}>
                                        {data.subtext}
                                        </p>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </section>
                <hr />
                <section className="text-center twoMidSections" id="noProgrammingRequiredSection">
                    <div className="card noProgrammingCard">
                        <div className="card-body">
                            <h2 className="card-title">No Programming Required!</h2>
                            <div className="card-text" style={{ fontSize: '20px' }}>
                                Our team of highly sophisticated and respected Software Engineers will create the bot for you and your business to get you the best results with the lowest cost.
                            </div>
                        </div>
                        <img id="noProgrammingImage" alt="noProgramming"
                            src="https://firebasestorage.googleapis.com/v0/b/tinqertinquer.appspot.com/o/noProgrammingIllustration.png?alt=media&token=d38322dc-426f-472d-8a30-cac2f1688160" />
                    </div>
                </section>
                <hr /><br />
                <section className="text-center twoMidSections" id="contactUsForm">
                    <div className="card contactUsCard">
                        <div className="card-body">
                            <h1 className="card-title">Pricing</h1>
                            <div className="card-text">
                                Each business is unique.<br />
                                Please fill out the form to contact us about custom pricing, live demo, and to discuss your business needs.
                            </div>
                            <hr />
                            <form style={{ paddingRight: '30px', paddingLeft: '30px' }}>
                                <input type="text" className="form-control" id="nameInput" placeholder="Full Name" required />
                                <br />
                                <input type="text" className="form-control" id="businessNameInput" placeholder="Business Name" required /><br />
                                <input type="tel" className="form-control" id="contactNumberInput" placeholder="Contact Number" required /><br />
                                <input type="email" className="form-control" id="emailInput" placeholder="Email Address" required /><br />
                                <input type="url" className="form-control" id="businessWebsiteInput" placeholder="Website URL" required /><br />
                                <textarea className='form-control' id='summaryArea' rows='3' placeholder="Short Introduction" required></textarea><br />
                            </form>
                            <button className="btn" id='contactUsButton'
                                onClick={() => this.contactUs()}
                            >Contact Us</button>
                            <br />
                            <small id='errorArea'> </small>
                        </div>
                    </div>
                </section>
                <hr />
                <Modal ref='denyModal' modalStyle={style.modalStyle}>
                    <br />
                    <h3>Please fill out the required information</h3>
                    <br />
                </Modal>
                <Modal ref='approvedModal' modalStyle={style.modalStyle}>
                    <br />
                    <h3>Thank you! We will contact you as soon as possible!</h3>
                    <br />
                </Modal>
            </div>
        );
    }
}

export default Chatbotdisplay;


// WEBPACK FOOTER //
// ./src/Homepage/Chatbotdisplay.js